import { createContext } from 'react'

export default createContext({
  filters: [],
  formikProps: {},
})
